import { stylesheet } from 'astroturf';
import styled from 'astroturf/react';
import Svg from 'src/components/Svg';

const SelectBox = styled('label')`
  position: relative;
  display: flex;
  width: 100%;

  & + & {
    border-top: 0;
  }
`;

const SelectBoxLabel = styled('div')`
  font-size: var(--ph-text-sm);
  display: flex;
  justify-content: space-between;
  flex: 0 0 30%;
  padding: 20px;
  line-height: 1.54;
  align-items: center;
  color: var(--ph-gray-500);
  overflow: hidden;
  text-overflow: ellipsis;
`;

const SelectBoxContainer = styled('div')`
  width: 100%;
  height: 100%;
`;

const SelectBoxRequired = styled('span')`
  position: relative;
  top: 2px;
  color: var(--ph-red-500);
`;

const Stylesheets = stylesheet`
  .react-select {
    position: relative;
  }

  .react-select__control {
    min-height: 30px !important;
    height: auto !important;
    border: 1px solid var(--ph-gray-100) !important;
    border-radius: var(--ph-border-radius-sm) !important;
    cursor: pointer !important;
    background-color: var(--white) !important;

    &--is-focused {
      box-shadow: var(--ph-box-shadow-focus) !important;
    }
  }

  .react-select__value-container {
    font-size: var(--ph-text-sm) !important;
    line-height: 1.25 !important;
    height: 100% !important;
    padding: 0 5px !important;
  }

  .react-select__single-value {
    margin: 0 !important;
    color: var(--black) !important;
  }

  .react-select__indicator-separator {
    display: none !important;
  }

  .react-select__multi-value {
    height: auto !important;
    padding: 5px 5px 5px 15px !important;
    border-radius: var(--ph-border-radius-sm) !important;
    border: 0 !important;
    background-color: var(--ph-gray-500) !important;
    justify-content: center;
    align-items: center;
  }

  .react-select__multi-value__label {
    font-size: 1.6rem !important;
    color: var(--white) !important;
    padding: 0 !important;
    max-width: 200px !important;
  }

  .react-select__multi-value__remove {
    padding: 0 7px !important;
    color: var(--white) !important;
    opacity: 0.4;
    cursor: pointer;

    &:hover {
      background-color: transparent !important;
      color: var(--white) !important;
      opacity: 1;
    }
  }

  .react-select__menu-notice--no-options {
    font-size: var(--ph-text-sm);
    font-weight: normal;
    font-stretch: normal;
    line-height: 1.25;
    letter-spacing: normal;
    color: var(--ph-gray-500) !important;
    text-align: left !important;
  }

  .react-select__menu-notice--loading div {
    justify-content: left;
  }

  .react-select__indicator {
    padding: 0 5px !important;
  }

  .react-select__menu {
    background-color: var(--white) !important;
    border-radius: var(--ph-border-radius-sm) !important;
    box-shadow: var(--ph-box-shadow-sm) !important;
    margin-bottom: 1px !important;
    margin-top: 1px !important;
    left: -1px;
    box-sizing: content-box !important;
  }

  .react-select__menu-list {
    max-height: 120px !important;
    padding-top: 1px !important;
    padding-bottom: 1px !important;
  }

  .react-select__option {
    cursor: pointer !important;
    transition: var(--ph-background-transition);
    font-size: var(--ph-text-sm) !important;
    padding: 10px !important;
    color: var(--black) !important;
    word-break: break-word;
    text-align: left;
  }

  .react-select__option--is-focused {
    background-color: rgba(var(--ph-gray-rgb-50), 0.5) !important;
  }

  .react-select__option--is-selected {
    background-color: rgba(var(--ph-gray-rgb-50), 0.8) !important;
  }

  .react-select--is-disabled .react-select__control {
    cursor: not-allowed !important;
    background-color: var(--ph-gray-50) !important;
    border: 1px solid var(--ph-gray-100) !important;
  }

  .react-select--is-disabled .react-select__single-value {
    cursor: not-allowed !important;
    color: var(--ph-gray-300) !important;
  }

  .react-select__option--is-disabled {
    opacity: 0.5;
    text-decoration: line-through;
  }
`;

const SelectBoxError = styled('div')`
  font-size: 1.2rem;
  color: var(--ph-red-500);
  position: absolute;
  right: 6px;
  top: 2px;
  width: 59%;
  text-align: right;
  pointer-events: none;
`;

const QuestionTypeIcon = styled(Svg)`
  width: 25px;
  margin-right: 10px;
  vertical-align: middle;
`;

export default {
  SelectBox,
  SelectBoxLabel,
  SelectBoxRequired,
  SelectBoxContainer,
  Stylesheets,
  SelectBoxError,
  QuestionTypeIcon,
};
